
<div class="contentRouter" fxLayout="column" fxLayoutAlign="space-between center">
  <router-outlet style="min-height: 100%; "></router-outlet>
  <!-- <app-footer
  ></app-footer> -->
  <app-mfe-footer></app-mfe-footer>
</div>
